enum AdminRole {
  Moderator = "moderator",
  Admin = "admin"
}

export default AdminRole;
